module.exports = __webpack_public_path__ + "media/images/Munya_Dimairo-ef0d9d68f92101d825a958db45695a00.jpg";